// src/routes/slidersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Sliders from '../pages/sliders/Sliders';
import CreateSlider from '../pages/sliders/CreateSlider';
import EditSlider from '../pages/sliders/EditSlider';
import ProtectedRoute from '../components/global/ProtectedRoute';

const slidersRoutes = (
    <>
        {/* Sliders List */}
        <Route
            path="/sliders"
            element={
                <ProtectedRoute requiredPermission="viewAny-slider">
                    <Sliders />
                </ProtectedRoute>
            }
        />

        {/* Create Slider */}
        <Route
            path="/sliders/create"
            element={
                <ProtectedRoute requiredPermission="create-slider">
                    <CreateSlider />
                </ProtectedRoute>
            }
        />

        {/* Edit Slider */}
        <Route
            path="/sliders/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-slider">
                    <EditSlider />
                </ProtectedRoute>
            }
        />
    </>
);

export default slidersRoutes;